import { IconButton } from '@mui/material';
import styled from 'styled-components';
export const StyledInput = styled.input `
  display: none;
`;
export const AddFileImage = styled.img `
  width: 24px;
  height: 24px;
`;
export const DisabledIconButton = styled(IconButton) `
  && {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
